export default __webpack_public_path__ + "static/media/logo.e8a8d9e3.svg";